
      import { createComponent } from '@lit/react'
      import { type EventName } from '@lit/react'
      import * as React from 'react'

      import Component from '../../components/avatar-group/avatar-group.component.js'
      import type { DdsOverflowClickEvent } from '../../events/events'
      export type { DdsOverflowClickEvent } from '../../events/events'

      const tagName = 'dap-ds-avatar-group'

      /**
 * `dap-ds-avatar-group`
 * @summary Avatar group component displays multiple avatars in an organized layout with overflow management.
 * @element dap-ds-avatar-group
 * @title - Avatar Group
 * @group avatar
 *
 * @slot - The avatars to display in the group.
 *
 * @event dds-overflow-click - Fired when the overflow indicator is clicked.
 *
 * @csspart base - The main container of the avatar group.
 * @csspart avatars - The container for the visible avatars.
 * @csspart overflow - The overflow indicator element.
 *
 * @cssproperty --dds-avatar-group-gap - Gap between avatars in grid layout. Default is 0.
 * @cssproperty --dds-avatar-group-overlap - Overlap amount for stacked layout. Default is -8px.
 * @cssproperty --dds-avatar-group-border-width - Border width for avatars. Default is 2px.
 * @cssproperty --dds-avatar-group-border-color - Border color for avatars. Default is white.
 * @cssproperty --dds-avatar-group-overflow-bg - Background color for overflow indicator.
 * @cssproperty --dds-avatar-group-overflow-color - Text color for overflow indicator.
 * @cssproperty --dds-avatar-group-overflow-border - Border for overflow indicator.
 * @cssproperty --dds-avatar-group-size-lg - Size for large avatars. Default is 80px.
 * @cssproperty --dds-avatar-group-size-md - Size for medium avatars. Default is 64px.
 * @cssproperty --dds-avatar-group-size-sm - Size for small avatars. Default is 48px.
 * @cssproperty --dds-avatar-group-size-xs - Size for extra small avatars. Default is 32px.
 * @cssproperty --dds-avatar-group-size-xxs - Size for extra extra small avatars. Default is 24px.
 */
      const reactWrapper = createComponent({
        tagName,
        elementClass: Component,
        react: React,
        events: {
          onDdsOverflowClick: 'dds-overflow-click' as EventName<DdsOverflowClickEvent>
        },
        displayName: "DapDSAvatarGroup"
      })

      export default reactWrapper
    